/* @flow */
import * as React from "react";
import Inviting from "./ReferralBonus";
import Invitee from "./ReferralBonusSlave";

// Приглашающий и приглашённый.
// Аналогии с рабами и их хозяевами это не окей.

import type { DepositBonusInserted as Bonus } from "../../../redux/CommonTypes";

export default function ReferralBonusModal(
  props: Bonus & { onDismiss: Function }
) {
  switch (props.bonus_type) {
    case 0:
      return <Inviting {...props} />;
    case 1:
      return <Invitee {...props} />;
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/TradeModals/ReferralBonus/index.js